<template>
  <div>
    <v-img id="image" src="@/assets/images/1.jpg">
      <template v-slot:placeholder>
        <v-row
        class="fill-height ma-0"
        align="center"
        justify="center"
        >
        <v-progress-circular
            indeterminate
            color="grey lighten-5"
        ></v-progress-circular>
        </v-row>
    </template>
    <v-container fluid class="pt-0" fill-height>
      <v-row justify="end">
        <v-col  cols="12" md="6" :class="(viewSize) == 'md'? 'container_background' : 'm-container_background'">
          <v-carousel
          hide-delimiter-background
          delimiter-icon="mdi-circle"
          cycle
          >
          <v-carousel-item>
            <v-sheet class="v-sheet" height="100%">
              <v-row
                class="fill-height mx-12"
                align="center"
                justify="center"
                no-gutters
              >
                <v-col cols="11">
                  <div class="text-h3 white--text">Műszaki szakképzettség</div>
                  <p class="white--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries</p>  
                  
                </v-col>
                
              </v-row>
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet class="v-sheet" height="100%">
              <v-row
                class="fill-height mx-12"
                align="center"
                justify="center"
                no-gutters
              >
                <v-col cols="11">
                  <div class="text-h3 white--text">ISO 9001 tanusítvány</div>
                  <p class="white--text">A BNS Mérnökiroda Kft. az ISO 9001:2008 szabvány követelményei szerint alakította ki minőséirányítási rendszerét.</p>  
                  <v-btn tile to="/iso">Bővebben</v-btn>
                </v-col>
                
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        </v-col>
      </v-row>
    </v-container>
    </v-img>
    <div class="mt-5" align="center">
      <v-row no-gutters justify="center" align="center">
        <InfoBox title="Rólunk" text="Cégünk a magas szintű műszaki szakmaiságot biztosítja!" :icon="icons[1]" href="/rolunk"/>
        <InfoBox title="Beltéri gyártmányok" text="Automatizálás, műszerezés, villamosipari rendszerek tervezése, szerelése" :icon="icons[2]"/>
        <InfoBox title="Kültéri gyártmányok" text="Kültéri és beltéri egységek gyártásával is egyaránt foglalkozunk." :icon="icons[0]"/>
        
      </v-row>
    </div>
  </div>
</template>

<script>
  import InfoBox from '@/components/InfoBox.vue'
  import ImageUtil from '@/util/image_util.js'
  export default {
    name: 'Home',
    components: {
      InfoBox
    },
    data(){
      return{
        icons:[         
          "icons/box2.svg",          
          "icons/group.svg",
           "icons/box.svg"
        ]
      }
    },

    created:function(){
      this.icons = ImageUtil.loadImages(this.icons);
      if(this.$vuetify.breakpoint.mdAndUp){
        this.id='container'
      }
      else{
        this.id='m-container'
      }
    },

    computed: {
      viewSize() {
          return (this.$vuetify.breakpoint.mdAndUp) ? 'md' : 'sm';
      }
    }   
  }
</script>
<style scoped>
  #image{
    width:100vw;
  }
  .v-sheet{
    background-color: rgba(0, 0, 0, 0);
  }
  .container_background{
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.5))
  }
  .m-container_background{
    background-color: rgba(0, 0, 0, 0.7);
  }
</style>
